import React, { useState, useCallback } from 'react';
import { Box } from '@mui/material';
import { AppLayout } from './layout';
import GraphExplorer from './GraphExplorer';

/**
 * GraphExplorerWithLayout wraps the GraphExplorer with the unified AppLayout
 * providing the drawer with domains, subjects, courses, search, and AI assist.
 */
const GraphExplorerWithLayout: React.FC = () => {
  const [filteredSkillIds, setFilteredSkillIds] = useState<string[]>([]);
  const [selectedCourseName, setSelectedCourseName] = useState<string | null>(null);
  const [selectedDomain, setSelectedDomain] = useState<string | null>(null);
  const [selectedSubject, setSelectedSubject] = useState<string | null>(null);

  const handleSkillsFilter = useCallback((skillIdsOrNames: string[]) => {
    console.log('[GraphExplorerWithLayout] Filtering to skills (raw):', skillIdsOrNames);
    setFilteredSkillIds(skillIdsOrNames);
  }, []);

  const handleCourseSelect = useCallback((courseName: string, coreSkills: string[]) => {
    console.log('[GraphExplorerWithLayout] Course selected:', courseName, 'skills:', coreSkills);
    setSelectedCourseName(courseName);
    // Filtering is handled by AppLayout via onSkillsFilter
  }, []);
  
  const handleDomainSelect = useCallback((domain: string | null) => {
    console.log('[GraphExplorerWithLayout] Domain selected:', domain);
    setSelectedDomain(domain);
  }, []);

  const handleSubjectSelect = useCallback((subject: string | null) => {
    console.log('[GraphExplorerWithLayout] Subject selected:', subject);
    setSelectedSubject(subject);
  }, []);

  return (
    <AppLayout 
      onSkillsFilter={handleSkillsFilter}
      onCourseSelect={handleCourseSelect}
      onDomainSelect={handleDomainSelect}
      onSubjectSelect={handleSubjectSelect}
    >
      <Box sx={{ width: '100%', height: '100%' }}>
        <GraphExplorer 
          filteredSkillIds={filteredSkillIds}
          selectedCourseId={selectedCourseName}
          selectedDomainProp={selectedDomain}
          selectedSubjectProp={selectedSubject}
          showSearch={false}
          showDomains={false}
        />
      </Box>
    </AppLayout>
  );
};

export default GraphExplorerWithLayout;
